

//! Quality Url
const BASE_URL = "https://apxappdev.noidapower.com:8164";  
//! Quality Url
// const BASE_URL = "https://gtw5.noidapower.com:9174";  
//! Prod Url
// const BASE_URL = "https://cportal.chandigarhpower.com:9180";  
//! Development Api Url
const apiEndpoints = {
  getAllAreas: `${BASE_URL}/chdd/master/Consumer_Master_Dev/location_master_details_return_zone_division`,
  getAreaWiseInformation: `${BASE_URL}/chdd/master/Consumer_Master_Dev/location_master_detail_all`,
  addFeedback: `${BASE_URL}/chdd/master/Consumer_Master_Dev/location_master_detail_all`,
};
// //! Quality Api Url
// const apiEndpoints = {
// };
//! Prod Api
// const apiEndpoints = {
// };
export default apiEndpoints;
